import { render } from "./IconCloud.vue?vue&type=template&id=419c00d3"
const script = {}
script.render = render

export default script